/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {MergeSelectionPayload, SelectionFeaturePayload} from './selection.model';

export class ClearSelection {
    static readonly type = '[Query Service] Clear Selection';
}

export class SetSelection {
    static readonly type = '[Query Service] Set selection';

    constructor(public payload?: SelectionFeaturePayload[]) {}
}

export class AddLayerSelection {
    static readonly type = '[Query Service] Add layer selection';

    constructor(public payload: SelectionFeaturePayload) {}
}

export class MergeLayerSelection {
    static readonly type = '[Query Service] Merge layer selection';

    constructor(public payload: SelectionFeaturePayload) {
    }
}

export class MergeSelection {
    static readonly type = '[Query Service] Merge selection';

    constructor(public payload: MergeSelectionPayload) {
    }
}

export class RefreshSelection {
    static readonly type = '[Query Service] Refresh selection';
}
